import React, { memo, useCallback, useMemo, useState } from 'react';
import { List } from '../list';
import { Item } from './item';
import { isNil } from 'ramda';
export const Items = memo(({ items, onItemClick, checkSelection }) => {
    const [isOpen, toggleCollapse] = useState(Object.create(null));
    const isFlat = useMemo(() => {
        return !items.some((i) => i.children);
    }, [items]);
    const toggle = useCallback((item, isOpen) => {
        toggleCollapse((oldValue) => {
            const toggledValue = isNil(isOpen) ? !Boolean(oldValue[item.id]) : isOpen;
            if (oldValue[item.id] !== toggledValue) {
                return { ...oldValue, [item.id]: toggledValue };
            }
            return oldValue;
        });
    }, [toggleCollapse]);
    const itemComponents = useMemo(() => items.map((item, index, list) => (React.createElement(Item, { key: item.id, item: item, toggle: toggle, isOpen: Boolean(isOpen[item.id]), isFlat: isFlat, onItemClick: onItemClick, checkSelection: checkSelection, isLatest: index === list.length - 1 }))), [toggle, isOpen, isFlat, items, checkSelection]);
    return React.createElement(List, null, itemComponents);
});
